import { useEffect, useState } from 'react'

import { useGetSendOptionsQuery } from 'common'

import { SendFromCalendlyEmailModal } from './send-from-calendly-email-modal'

export const SendFromCalendlyEmailModalProvider = (
  {
    isOpen,
    onClose,
    onConfirm,
    onBack,
    isLoading,
    title,
    subTitle,
    initialSubject,
    initialBody,
    showCancellationPolicyCheckbox = true,
    eventType,
    userData,
    contact,
    source
  }
) => {
  const { data, isSuccess } = useGetSendOptionsQuery({ ownerType: 'users', ownerId: 'me' })
  const [sendOptions, setSendOptions] = useState([])

  useEffect(() => {
    if (isSuccess) {
      setSendOptions(data.sendOptions || [])
    }
  }, [isSuccess, data])

  return (
    <SendFromCalendlyEmailModal
      isOpen={isOpen}
      onClose={onClose}
      onConfirm={onConfirm}
      onBack={onBack}
      emails={sendOptions}
      isLoading={isLoading}
      title={title}
      subTitle={subTitle}
      initialBody={initialBody}
      initialSubject={initialSubject}
      showCancellationPolicyCheckbox={showCancellationPolicyCheckbox}
      eventType={eventType}
      userData={userData}
      contact={contact}
      source={source}
    />
  )
}
